import { Backdrop, Box, Button, Grid, TextField, Typography } from '@mui/material';
import AppLoader from '../../../components/AppLoader/AppLoader';
import { useFormik } from 'formik';
import React, { useEffect, useState } from 'react';
import * as Yup from "yup";
import { cfpBaseUrl } from '../../../network/urls';
import { portalName } from '../../../utils/PortalName';
import { resolveDiscoCompanyCodeForBranding } from '../../../utils/adminCompany';
import "../../GeneralServices/NewConnection/NewConnectionForm.scss";
//jspdf
import { jsPDF } from "jspdf";
import "jspdf-autotable";
//jsbarcode
import DescriptionIcon from '@mui/icons-material/Description';
import FormSubmissionSuccessDialog from '../../../components/FormSubmissionSuccessDialog/FormSubmissionSuccessDialog';
import JsBarcode from "jsbarcode";
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import CustomerInformationCard from '../../../components/CustomerInformationCard/CustomerInformationCard';
import Error from '../../../components/error/error';
import mepcologo from "../../../images/mepcoLogo.png";
import MEPCOWaterMark from '../../../images/DiscosWater/mepcco-watermark.png';
import LESCOWaterMark from '../../../images/DiscosWater/lescowatermark.png';
import IESCOWaterMark from '../../../images/DiscosWater/iescowatermark.png';
import FESCOWaterMark from '../../../images/DiscosWater/fesco-watermark.png';
import GEPCOWaterMark from '../../../images/DiscosWater/gepco-watermark.png';
import HAZECOWaterMark from '../../../images/DiscosWater/hazeco-watermark.png';
import HESCOWaterMark from '../../../images/DiscosWater/hesco-watermark.png';
import TESCOWaterMark from '../../../images/DiscosWater/tesco-watermark.png';
import SEPCOWaterMark from '../../../images/DiscosWater/sepco-watermark.png';
import PESCOWaterMark from '../../../images/DiscosWater/pesco-watermark.png';
import QESCOWaterMark from '../../../images/DiscosWater/qesco-watermark.png';
import { companyShortName, convertDate, dBillAPI, downloadBill, getMeterType, getPhase, getRelevantCFCCode, numberFormatting, pendingPayments, subDivAPI, subdivisionName } from '../../../services/Functions';

const BillCorrectionForm = () => {
  const initialValues = {
    // Classification group Initial Values
    iv_consumer_id: '',
    iv_reference_number: '',
    iv_circle: '',
    iv_division: '',
    iv_sub_divison: '',
    iv_address: '',
    // Installment Details field
    iv_bill_month: '',
    iv_net_bill: '',
    iv_arrears: '',
    iv_due_date: '',
    // Applicant Details group Initial Values
    iv_applicant_name: '',
    iv_father_name: '',
    iv_applicant_cnic: '',
    iv_applicant_phone_no: '',
    iv_applicant_email: '',
    // Required Documents Initial Values
    iv_connection_type: '',
    iv_tariff_description: '',
    iv_tariff_code: '',
    iv_cc_code: '',
    iv_sanctioned_load: '',
    iv_meter_type: '',
    iv_phase: '',

    iv_last_paid_amount: [],
    iv_paid_on: [],
    iv_paid_flag: [],

  }
  // Classification Group States
  const [referenceNumber, setReferenceNumber] = useState('');
  const [subDivision, setSubDivision] = React.useState({ code: null, name: '' });
  const [viewBackdrop, setViewBackdrop] = useState(false);
  const [applicationId, setApplicationId] = useState();
  const [billCorrectionPopup, setBillCorrectionPopup] = useState();
  const navigate = useNavigate();
  const [searchBy, setSearchBy] = useState('referenceNo');
  const [isPendingPayments, setIsPendingPayments] = useState(false)
  // Thumbnail states
  const [installmentsProvisions, setInstallmentProvisions] = useState();
  const { data: installmentProvisions } = useSelector((state) => state.provisions)

  // States for hiding conditional fields
  const [hierarchyList, setHierarchyList] = useState([]);
  const [circleList, setCircleList] = useState([]);
  const [divisionList, setDivisionList] = useState([]);
  const [subDivisionList, setSubDivisionList] = useState([]);
  const [defaultCircle, setDefaultCircle] = useState();
  const [defaultDivision, setDefaultDivision] = useState();
  const [error, setError] = useState();
  const [customerId, setCustomerId] = useState(null);
  const { token, code: userCode, userId, cfcLevelId, roleId, selectedAdminCompanyCode } = useSelector((state) => state.auth)

  const [billInstallmentApplicationId, setBillInstallmentApplicationId] = useState('')

  let subDivisionsArray = JSON.parse(window.localStorage.getItem("subDivisions"));

  let userCompany = resolveDiscoCompanyCodeForBranding(
    userCode,
    roleId,
    selectedAdminCompanyCode,
  );
 const getWaterMarkLogo = (code) => {
    switch (code) {
      case '11':
        return LESCOWaterMark
      case '12':
        return GEPCOWaterMark
      case '13':
        return FESCOWaterMark
      case '14':
        return IESCOWaterMark
      case '15':
        return MEPCOWaterMark
      case '26':
        return PESCOWaterMark
      case '27':
        return HAZECOWaterMark
      case '37':
        return HESCOWaterMark
      case '38':
        return SEPCOWaterMark
      case '48':
        return QESCOWaterMark
      case '59':
        return TESCOWaterMark
      default:
        return MEPCOWaterMark
    }
  }
  const errorCloses = () => {
    setError('')
  }

  const SearchBy = (event) => {
    values.iv_search_by = event.target.value;
    setSearchBy(event.target.value);
    setDefaultCircle('')
    setDefaultDivision('')
    setError('')
    setSubDivision('')
    values.iv_meter_type = ''
    values.iv_phase = ''
    values.iv_due_date = ''
    resetForm()
    values.iv_address = ''
    values.iv_sanctioned_load = ''
    values.iv_circle = ''
    values.iv_division = ''
    values.iv_sub_divison = ''
    values.iv_consumer_id = ''
    values.iv_reference_number = ''
    values.iv_applicant_name = ''
    values.iv_father_name = ''
    values.iv_connection_type = ''
    values.iv_tariff_code = ''
    values.iv_tariff_description = ''
    values.iv_applicant_cnic = ''
    values.iv_applicant_phone_no = ''
    values.iv_applicant_email = ''
    values.iv_net_bill = ''
    values.iv_arrears = ''
    values.iv_last_paid_amount = []
    values.iv_paid_on = []
    values.iv_paid_flag = []
    setReferenceNumber('');
    setCustomerId(null)
  };

  const referedToCFCLevelId = (totalBillAmount, noOfInstallments) => {
    if (installmentsProvisions) {
      let referedToCFCLevelId = 0;
      let instProvAccToNos = installmentsProvisions.filter((item) => item.noOfActions == noOfInstallments)
      let instProvAccToBillAmount = instProvAccToNos.find((item) => (item.amountFrom <= totalBillAmount) && (item.amountTo >= totalBillAmount))
      if (instProvAccToBillAmount.cfcLevelId) {
        referedToCFCLevelId = instProvAccToBillAmount.cfcLevelId
      }
      return referedToCFCLevelId
    }
  }

  const getFinalCFCLevelId = (initialReferedToCFCId, loggedInUserCFCId) => {
    if (initialReferedToCFCId && loggedInUserCFCId) {
      if (initialReferedToCFCId == loggedInUserCFCId) {
        return initialReferedToCFCId
      } else if (loggedInUserCFCId > initialReferedToCFCId) {
        return initialReferedToCFCId
      } else if (loggedInUserCFCId < initialReferedToCFCId) {
        return loggedInUserCFCId
      }
    }
  }

  const getOfficeCode = (referedToCFCLevelId, referenceNo) => {
    let officeCode = ''
    if (referedToCFCLevelId == 2) {
      officeCode = referenceNo.slice(2, 4)
    } else if (referedToCFCLevelId == 3) {
      officeCode = referenceNo.slice(2, 5)
    } else if (referedToCFCLevelId == 4) {
      officeCode = referenceNo.slice(2, 6)
    } else if (referedToCFCLevelId == 5) {
      officeCode = referenceNo.slice(2, 7)
    }
    return officeCode
  }

  const getRelevantCFCId = async (totalBill, noOfInst, referenceNo) => {
    if (installmentsProvisions) {
      let referedToCFCId = ''
      let initialReferedToCFCId = referedToCFCLevelId(totalBill, noOfInst)
      if (!(initialReferedToCFCId == parseInt(cfcLevelId))) {
        let referedToCFCLevelId = getFinalCFCLevelId(initialReferedToCFCId, parseInt(cfcLevelId))
        let officeCode = getOfficeCode(referedToCFCLevelId, referenceNo)
        referedToCFCId = await getRelevantCFCCode(token, officeCode, referedToCFCLevelId)
      } else {
        referedToCFCId = userCode
      }
      return referedToCFCId
    }
  }

  // Formik form submission and new connection API calling
  const { values, errors, touched, handleBlur, handleChange, handleSubmit, resetForm } = useFormik({
    initialValues,
    validationSchema: Yup.object().shape({
      iv_connection_type: Yup.string().required('Connection type is compulsory.'),
      iv_reference_number: Yup.string().when('iv_search_by', {
        is: () => searchBy === 'referenceNo',
        then: Yup.string().min(14, 'Reference No. must be 14 digits.').max(14, 'Reference No. must be 14 digits.').required("Enter reference number."),
        otherwise: Yup.string().optional()
      }),
      iv_consumer_id: Yup.string().when('iv_search_by', {
        is: () => searchBy === 'consumerId',
        then: Yup.string().min(10, 'Customer ID. must be 10 digits.').max(10, 'Customer ID. must be 10 digits.').required("Enter consumer Id."),
        otherwise: Yup.string().optional()
      }),
      iv_circle: Yup.mixed().required("Please select a circle."),
      iv_division: Yup.mixed().required("Please select a division."),
      iv_sub_divison: Yup.mixed().required("Please select a sub division."),
      iv_net_bill: Yup.mixed().required("Can't apply! No current bill."),
      iv_arrears: Yup.mixed().optional(""),
      iv_due_date: Yup.string().required('Due date is required!'),
      iv_sanctioned_load: Yup.string().required('Load is required.'),
      iv_applicant_phone_no: Yup.string().max(11, "Please enter 11 digit phone number.").min(11, "Please enter 11 digit phone number.").optional("Please enter valid mobile number.").matches(/^03[0-9]{2}[0-9]{7}$/, "Enter Phone number as 03001234567"),
    }),
    onSubmit: async (values, { resetForm }) => {
      if (isPendingPayments) {

        setViewBackdrop(true)
        const myHeaders = new Headers();
        myHeaders.append("Authorization", token);
        myHeaders.append("Content-Type", "application/json");

        let appProgId = 3

        const raw = JSON.stringify({
          billInstallmentApplicationId: billInstallmentApplicationId,
          applicantMobileNo: values.iv_applicant_phone_no,
          arrearsAmount: values.iv_arrears,
          billAmount: values.iv_net_bill,
          billMonth: values.iv_bill_month,
          // billPaymentDate: '',
          cfcId: userCode,
          circleCode: defaultCircle.code,
          companyCode: parseInt(defaultCircle.code.toString().slice(0, 2)),
          connectionCategory: values.iv_connection_type,
          consumerAddress: values.iv_address,
          consumerCNIC: values.iv_applicant_cnic,
          consumerFatherName: values.iv_father_name,
          consumerName: values.iv_applicant_name,
          createdBy: userId,
          customerId: customerId,
          divisionCode: defaultDivision.code,
          referenceNo: referenceNumber,
          remarks: "Application Submitted",
          sanctionedLoad: values.iv_sanctioned_load,
          subDivisionCode: subDivision.code,
          submittedThrough: portalName,
          tariffCode: values.iv_tariff_code,
          applicantStatus: "Owner", //"Owner / Tenant"
          meterType: getPhase(values.iv_sanctioned_load),
          applicationProgressId: appProgId,
          ntn: "",
          strn: "",
        });

        const requestOptions = {
          method: "POST",
          headers: myHeaders,
          body: raw,
          redirect: "follow"
        };

        await fetch(cfpBaseUrl + "billCorrection/registerBillCorrectionApplication", requestOptions)
          .then(async (response) => {
            if (response.status == 200) {
              return response.json()
            } else {
              let res = await response.json()
              setError(res.message)
            }
          })
          .then(async (result) => {
            if (result.status == '200') {
              const applicationID = result.applicationId
              setApplicationId(result.applicationId)
              setBillCorrectionPopup(true)
              // printApplicationReceipt(values, applicationID, userId, referenceNumber);
              resetForm()
              setDefaultCircle()
              setDefaultDivision()
              setSubDivision()
            }
            else {
              if (result.message.startsWith('Disconnection date can not be null or empty')) {
                setError(result.message)
              } else {
                setError('The meter is already connected.')
              }
            }
          })
          .catch(() => {});
      }
      else {
        setError('No payment is pending against reference no.')
      }
      setViewBackdrop(false)
    }
  })

  useEffect(() => {
    const loadSubDivs = async () => {
      if (userCompany && cfpBaseUrl && token) {
        setViewBackdrop(true)
        const lists = await subDivAPI(userCompany, cfpBaseUrl, token)
        setHierarchyList(lists.hierarchyList)
        setCircleList(lists.circleList)
        setDivisionList(lists.divisionList)
        setSubDivisionList(lists.subDivisionList)
        setViewBackdrop(false)
      }
    }
    loadSubDivs()
  }, []);

  useEffect(() => {
    if (!hierarchyList || !defaultCircle) return;

    const uniqueDivisions = hierarchyList
      .filter(division => division.circleCode === defaultCircle.code)
      .reduce((uniqueDivisions, division) => {
        const existingDivision = uniqueDivisions.find(d => d.code === division.divisionCode);
        if (!existingDivision) {
          uniqueDivisions.push({
            code: division.divisionCode,
            name: division.divisionName,
          });
        }
        return uniqueDivisions;
      }, []);

    const sortedDivisionArray = uniqueDivisions.sort((a, b) => a.name.localeCompare(b.name, 'en', { ignorePunctuation: true }));

    setDivisionList(sortedDivisionArray);
  }, [defaultCircle, hierarchyList]);

  useEffect(() => {
    let provis = installmentProvisions.filter((item) => item.id == 8)
    setInstallmentProvisions(provis)
  }, [installmentProvisions])

  useEffect(() => {
    if (!defaultDivision || !hierarchyList) return;

    const uniqueSubDivisions = hierarchyList
      .filter(subDivision => subDivision.divisionCode === defaultDivision.code)
      .reduce((uniqueSubDivisions, subDivision) => {
        const existingSubDivision = uniqueSubDivisions.find(s => s.code === subDivision.subDivisionCode);
        if (!existingSubDivision) {
          uniqueSubDivisions.push({
            code: subDivision.subDivisionCode,
            name: subDivision.subDivisionName,
          });
        }
        return uniqueSubDivisions;
      }, []);

    const sortedSubDivisionArray = uniqueSubDivisions.sort((a, b) => a.name.localeCompare(b.name, 'en', { ignorePunctuation: true }));

    setSubDivisionList(sortedSubDivisionArray);
  }, [defaultDivision, hierarchyList]);

  // Calling Billing API to fetch near by details
  useEffect(() => {
    if (referenceNumber.length === 14) {
      let enteredReferenceNo = referenceNumber;
      let circleCode = enteredReferenceNo.slice(2, 5);
      let circleObject = circleList.find(item => item.code === parseInt(circleCode));

      if (!circleObject) {
        // Handle circle not found
        setError(`Circle not found with code: ${circleCode}`);
        return;
      }

      setDefaultCircle(circleObject);
      values.iv_circle = circleObject.code;

      let divisionCode = enteredReferenceNo.slice(2, 6);
      let subDivisionCode = enteredReferenceNo.slice(2, 7);

      let uniqueDivisions = [];

      for (let i = 0; i < hierarchyList.length; i++) {
        const division = hierarchyList[i];
        if (division.circleCode === parseInt(circleCode)) {
          const existingDivision = uniqueDivisions.find(c => c.code === division.divisionCode);
          if (!existingDivision) {
            uniqueDivisions.push({
              code: division.divisionCode,
              name: division.divisionName,
            });
          }
        }
      }

      let sortedDivisionArray = uniqueDivisions.sort((a, b) =>
        a.name.localeCompare(b.name, undefined, { sensitivity: "base" })
      );
      let defDivision = sortedDivisionArray.find(item => item.code === parseInt(divisionCode));

      if (!defDivision) {
        // Handle division not found
        setError(`Division not found with code: ${divisionCode}. Contact Admin!`);
        return;
      }

      setDefaultDivision(defDivision);
      values.iv_division = defDivision.code;
      setDivisionList(sortedDivisionArray);

      let uniqueSubDivisions = [];

      for (let i = 0; i < hierarchyList.length; i++) {
        const subDivision = hierarchyList[i];
        if (subDivision.divisionCode === parseInt(divisionCode)) {
          const existingSubDivision = uniqueSubDivisions.find(c => c.code === subDivision.subDivisionCode);
          if (!existingSubDivision) {
            uniqueSubDivisions.push({
              code: subDivision.subDivisionCode,
              name: subDivision.subDivisionName,
            });
          }
        }
      }

      let sortedSubDivisionArray = uniqueSubDivisions.sort((a, b) =>
        a.name.localeCompare(b.name, undefined, { sensitivity: "base" })
      );

      let subDivisionObject = sortedSubDivisionArray.find(item => item.code === parseInt(subDivisionCode));
      if (!subDivisionObject) {
        // Handle subdivision not found
        setError(`Subdivision not found with code: ${subDivisionCode}. Contact Admin!`);
        return;
      }

      values.iv_sub_divison = subDivisionObject.code;
      setSubDivision(subDivisionObject);
      setSubDivisionList(sortedSubDivisionArray);
    }
  }, [referenceNumber]);

  useEffect(() => {
    if (values.iv_consumer_id.length === 10) {
      referenceApi();
    } else {
      setDefaultCircle('')
      setDefaultDivision('')
      setError('')
      setSubDivision('')
      values.iv_meter_type = ''
      values.iv_phase = ''
      values.iv_due_date = ''
      values.iv_address = ''
      values.iv_sanctioned_load = ''
      values.iv_circle = ''
      values.iv_division = ''
      values.iv_sub_divison = ''
      values.iv_reference_number = ''
      values.iv_applicant_name = ''
      values.iv_father_name = ''
      values.iv_applicant_cnic = ''
      values.iv_applicant_phone_no = ''
      values.iv_applicant_email = ''
      values.iv_net_bill = ''
      values.iv_arrears = ''
      values.iv_connection_type = ''
      values.iv_tariff_description = ''
      values.iv_tariff_code = ''
      values.iv_bill_month = ''
      values.iv_cc_code = ''
      values.iv_last_paid_amount = []
      values.iv_paid_on = []
      values.iv_paid_flag = []
      setReferenceNumber('')
      setCustomerId(null)
    }
  }, [values.iv_consumer_id])

  useEffect(() => {
    if (values.iv_reference_number.length === 14) {
      referenceApi();
    } else {
      setDefaultCircle('')
      setDefaultDivision('')
      setError('')
      setSubDivision('')
      values.iv_meter_type = ''
      values.iv_phase = ''
      values.iv_due_date = ''
      values.iv_address = ''
      values.iv_sanctioned_load = ''
      values.iv_circle = ''
      values.iv_division = ''
      values.iv_sub_divison = ''
      values.iv_consumer_id = ''
      values.iv_applicant_name = ''
      values.iv_father_name = ''
      values.iv_applicant_cnic = ''
      values.iv_applicant_phone_no = ''
      values.iv_applicant_email = ''
      values.iv_net_bill = ''
      values.iv_arrears = ''
      values.iv_connection_type = ''
      values.iv_tariff_description = ''
      values.iv_tariff_code = ''
      values.iv_bill_month = ''
      values.iv_cc_code = ''
      values.iv_last_paid_amount = []
      values.iv_paid_on = []
      values.iv_paid_flag = []
      setReferenceNumber('')
      setCustomerId(null)
    }
  }, [values.iv_reference_number])

  const referenceApi = async () => {
    if (searchBy === 'consumerId') {
      if (!values.iv_consumer_id) return;
      setViewBackdrop(true)
      let apiResponse = await dBillAPI(token, values.iv_consumer_id)
      if (apiResponse.status) {
        const basicInfo = apiResponse.basicInfo
        values.iv_address = basicInfo.consumerAddress1 + basicInfo.consumerAddress2
        values.iv_sanctioned_load = basicInfo.sactionLoad ? basicInfo.sactionLoad : '3'
        values.iv_net_bill = basicInfo.netBill ? basicInfo.netBill : 0
        values.iv_arrears = basicInfo.arrear ? basicInfo.arrear : 0
        values.iv_due_date = basicInfo.billDueDate
        values.iv_applicant_name = basicInfo.consumerName
        values.iv_father_name = basicInfo.consumerFName
        values.iv_applicant_cnic = basicInfo.owner_cnic
        values.iv_applicant_phone_no = basicInfo.consumerContactNo
        values.iv_applicant_email = basicInfo.consumerEmail
        values.iv_connection_type = basicInfo.cons_cat
        values.iv_tariff_description = basicInfo.tariffDescription
        values.iv_tariff_code = basicInfo.tariffCode
        values.iv_bill_month = basicInfo.billMonth.split('T')[0]
        values.iv_cc_code = basicInfo.cc_code ? basicInfo.cc_code : "1501"
        values.iv_phase = getPhase(basicInfo.sactionLoad)
        values.iv_meter_type = getMeterType(basicInfo.conn_catg, basicInfo.meterType, basicInfo.phase, apiResponse.metersInfo.length)
        setReferenceNumber(basicInfo.refNo.replace(/ /g, "").slice(0, 14))
        setCustomerId(basicInfo.appNo)
        await getPendingPayment(token, basicInfo.refNo.replace(/ /g, "").slice(0, 14))
      } else if (apiResponse.status == false) {
        setError('No Data Found against this Customer ID.')
         errors.iv_consumer_id = 'No Data Found against this Customer ID.'
      }else {
        setError('Customer ID. not found!')
        errors.iv_consumer_id = 'Customer ID. not found!'
      }
      setViewBackdrop(false)
    }
    if (searchBy === 'referenceNo') {
      if (!values.iv_reference_number) return;
      setViewBackdrop(true)
      let apiResponse = await dBillAPI(token, values.iv_reference_number)
      if (apiResponse.status) {
        const basicInfo = apiResponse.basicInfo
        values.iv_address = basicInfo.consumerAddress1 + basicInfo.consumerAddress2
        values.iv_sanctioned_load = basicInfo.sactionLoad ? basicInfo.sactionLoad : '3'
        values.iv_net_bill = basicInfo.netBill ? basicInfo.netBill : 0
        values.iv_arrears = basicInfo.arrear ? basicInfo.arrear : 0
        values.iv_due_date = basicInfo.billDueDate
        values.iv_applicant_name = basicInfo.consumerName
        values.iv_father_name = basicInfo.consumerFName
        values.iv_applicant_cnic = basicInfo.owner_cnic
        values.iv_applicant_phone_no = basicInfo.consumerContactNo
        values.iv_applicant_email = basicInfo.consumerEmail
        values.iv_connection_type = basicInfo.cons_cat
        values.iv_tariff_description = basicInfo.tariffDescription
        values.iv_tariff_code = basicInfo.tariffCode
        values.iv_bill_month = basicInfo.billMonth.split('T')[0]
        values.iv_cc_code = basicInfo.cc_code ? basicInfo.cc_code : "1501"
        values.iv_phase = getPhase(basicInfo.sactionLoad)
        values.iv_meter_type = getMeterType(basicInfo.conn_catg, basicInfo.meterType, basicInfo.phase, apiResponse.metersInfo.length)
        setReferenceNumber(basicInfo.refNo.replace(/ /g, "").slice(0, 14))
        setCustomerId(basicInfo.appNo)
        await getPendingPayment(token, basicInfo.refNo.replace(/ /g, "").slice(0, 14))
      } else if (apiResponse.status == false) {
        setError('No Data Found against this Reference No.')
         errors.iv_reference_number = 'No Data Found against this Reference No.'
      }else {
        setError('Reference No. not found!')
        errors.iv_reference_number = 'Reference No. not found!'
      }
      setViewBackdrop(false)
    }
  };

  const getPendingPayment = async (token, referenceNo) => {
    let response = await pendingPayments(token, referenceNo);
    if (response.rows.length > 0) {
      const amounts = response.rows.map(row => parseInt(row.PENDING_PAYMENT || 0));
      const dates = response.rows.map(row => row.PAYMENT_DATE || '');
      const flags = response.rows.map(row => row.IS_BILLED || 'N');

      const hasPendingPayment = amounts.some(amount => amount > 0);

      if (!hasPendingPayment) {
        setIsPendingPayments(false);
        setError('No payment is pending against reference no.');
      } else {
        setIsPendingPayments(true);
        setError('');
      }

      values.iv_last_paid_amount = amounts;
      values.iv_paid_on = dates;
      values.iv_paid_flag = flags;
    } else {
      setIsPendingPayments(false);
      setError('No payment is pending against reference no.');
    }
  };


  const printApplicationReceipt = (values, applicationID, userId, referenceNo) => {
    const doc = new jsPDF({ compressPdf: true });
    // Generate the barcode image using JsBarcode
    const barcodeCanvas = document.createElement("canvas");
    JsBarcode(barcodeCanvas, applicationID);

    // Convert the barcode image to data URL
    const barcodeDataURL = barcodeCanvas.toDataURL("image/png");
    var height = 10;
    var padding = 10;

    // Add the barcode image to the PDF document
    doc.addImage(barcodeDataURL, "PNG", 85, 260, 40, 20); // Adjust the position and size of the barcode image
    doc.addImage(mepcologo, "PNG", 90, height, 30, 10); // Adjust the position and size of the barcode image

    height = height + 20;

    var increment = 10;
    doc.setFontSize(15);
    doc.setFont("helvetica", "bold");
    doc.text(
      "Receipt of Reconnection Request",
      doc.internal.pageSize.getWidth() / 2,
      height,
      {
        align: "center",
      }
    );
    doc.setFontSize(12);
    increment = 20;
    height = height + increment;
    var leftMargin = 120;
    doc.text("DISCO / Company: ", padding, height);
    doc.text("Sub Division Code & Name:", padding + leftMargin, height);

    doc.setFont("helvetica", "normal");
    increment = 10;
    height = height + increment;
    leftMargin = 120;
    doc.text(
      companyShortName(values.iv_circle.toString().slice(0, 2)),
      padding,
      height
    );
    doc.text(
      values.iv_sub_divison.toString() +
      " / " +
      subdivisionName(values.iv_sub_divison, subDivisionsArray),
      // 'Sub Division Name',
      padding + leftMargin,
      height
    );

    increment = 10;
    height = height + increment;
    leftMargin = 40;
    doc.setFont("helvetica", "bold");
    doc.text("Tracking ID: ", padding, height);
    doc.setFont("helvetica", "normal");
    doc.text(applicationID.toString(), padding + leftMargin, height);
    leftMargin = 100;
    doc.setFont("helvetica", "bold");
    doc.text("Application Date: ", padding + leftMargin, height);
    doc.setFont("helvetica", "normal");
    leftMargin = 150;
    // Get the current date
    var currentDate = new Date();
    var formattedDate = currentDate.getDate() + ' ' +
      ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'][currentDate.getMonth()] + ' ' +
      currentDate.getFullYear();
    doc.text(formattedDate, padding + leftMargin, height);

    increment = 10;
    height = height + increment;
    leftMargin = 40;
    doc.setFont("helvetica", "bold");
    doc.text("Reference No: ", padding, height);
    doc.setFont("helvetica", "normal");
    doc.text(referenceNo, padding + leftMargin, height);
    leftMargin = 100;
    doc.setFont("helvetica", "bold");

    increment = 10;
    height = height + increment;
    leftMargin = 40;
    doc.setFont("helvetica", "bold");
    doc.text("Applicant Name: ", padding, height);
    doc.setFont("helvetica", "normal");
    doc.text(values.iv_applicant_name, padding + leftMargin, height);
    leftMargin = 100;
    doc.setFont("helvetica", "bold");
    doc.text("Mobile No.: ", padding + leftMargin, height);
    leftMargin = 130;
    doc.setFont("helvetica", "normal");
    doc.text(values.iv_applicant_phone_no, padding + leftMargin, height);

    increment = 10;
    height = height + increment;
    leftMargin = 40;
    doc.setFont("helvetica", "bold");
    doc.text("Issued By: ", padding, height);
    doc.setFont("helvetica", "normal");
    doc.text(userId, padding + leftMargin, height);

    const totalPages = doc.internal.getNumberOfPages();

    for (let i = 1; i <= totalPages; i++) {
      doc.setPage(i);
      doc.addImage(
        getWaterMarkLogo(userCompany),
        "PNG",
        0,
        0,
        doc.internal.pageSize.getWidth(),
        doc.internal.pageSize.getHeight()
      );
    }

    const pdfBlob = doc.output('blob');
    const pdfDataUrl = URL.createObjectURL(pdfBlob);

    // Open the PDF in a new tab
    window.open(pdfDataUrl, '_blank');

  };

  const handleClose = () => {
    setBillCorrectionPopup(false);
    navigate('/bill-correction-table')
  };

  return (
    <>
      <Grid container className='nC'>
        <Box className='nCContainer'>
          <div className="headingBarDiv">
            <h3 className="heading">
              Bill Correction
            </h3>
          </div>
          <form className='ncform'>
            <Typography variant="h6" className="groupTitle">
              <div className="redCell">
              </div>
              <div style={{ display: 'flex', width: '100%', justifyContent: 'space-between' }}>
                <span>
                  Applicant's Detail
                </span>
              </div>
            </Typography>
            <CustomerInformationCard
              searchBy={searchBy}
              SearchBy={SearchBy}
              errors={errors}
              values={values}
              touched={touched}
              handleChange={handleChange}
              handleBlur={handleBlur}
              defaultCircle={defaultCircle}
              circleList={circleList}
              setDefaultCircle={setDefaultCircle}
              defaultDivision={defaultDivision}
              divisionList={divisionList}
              setDefaultDivision={setDefaultDivision}
              subDivision={subDivision}
              subDivisionList={subDivisionList}
              setSubDivision={setSubDivision}
            />
            <Typography variant="h6" className="groupTitle">
              <div className="cyanCell">
              </div>
              Bill Detail
            </Typography>
            <Grid container className='container'>
              <Grid item xs={1} sx={{ paddingRight: '20px' }}>
                <Typography className='fieldLabel'>Bill Month</Typography>
                <TextField name="iv_bill_month"
                  required
                  type='text'
                  onBlur={handleBlur}
                  value={values.iv_bill_month ? convertDate(values.iv_bill_month) : ''}
                  disabled
                  className='textInputField1'
                />
                <Box className='from-Error'>
                  {errors.iv_bill_month && touched.iv_bill_month ? (errors.iv_bill_month) : null}
                </Box>
              </Grid>
              <Grid item xs={1} sx={{ paddingRight: '20px' }}>
                <Typography className='fieldLabel'>Arrears</Typography>
                <TextField name="iv_arrears"
                  required
                  type='text'
                  onBlur={handleBlur}
                  value={values.iv_arrears ? numberFormatting(values.iv_arrears) : ''}
                  disabled
                  className='textInputField1'
                />
                <Box className='from-Error'>
                  {errors.iv_arrears && touched.iv_arrears ? (errors.iv_arrears) : null}
                </Box>
              </Grid>
              <Grid item xs={1} sx={{ paddingRight: '20px' }}>
                <Typography className='fieldLabel'>Bill Amount</Typography>
                <TextField name="iv_net_bill"
                  required
                  type='text'
                  onBlur={handleBlur}
                  value={values.iv_net_bill ? numberFormatting(values.iv_net_bill) : ''}
                  disabled
                  className='textInputField1'
                />
                <Box className='from-Error'>
                  {errors.iv_net_bill && touched.iv_net_bill ? (errors.iv_net_bill) : null}
                </Box>
              </Grid>
              <Grid item xs={1} sx={{ paddingRight: '20px' }}>
                <Typography className='fieldLabel'>Due Date</Typography>
                <TextField
                  name="iv_due_date"
                  required
                  type='text'
                  onBlur={handleBlur}
                  value={values.iv_due_date ? convertDate(values.iv_due_date) : ''}
                  disabled
                  className='textInputField1' />
                <Box className='from-Error'>
                  {errors.iv_due_date && touched.iv_due_date ? (errors.iv_due_date) : null}
                </Box>
              </Grid>
              {/* <Grid item xs={1.10} sx={{ paddingRight: '20px' }}> 
                <Typography className='fieldLabel'>Last Paid Amount</Typography>
                <input
                  name="iv_last_paid_amount"
                  required
                  type='text'
                  onBlur={handleBlur}
                  value={values.iv_last_paid_amount ? numberFormatting(values.iv_last_paid_amount) : ''}
                  disabled
                  className='textInputField1'
                  style={{
                    width: '100%',
                    backgroundColor: '#006ad1', // Set background color here
                    color: 'white', // Set background color here
                    borderRadius: '5px',
                    height: '32.5px',
                    border: '1px solid lightgrey',
                    padding: '0px 5px'
                  }}
                />
                <Box className='from-Error'>
                  {errors.iv_last_paid_amount && touched.iv_last_paid_amount ? (errors.iv_last_paid_amount) : null}
                </Box>
              </Grid>
              <Grid item xs={1} sx={{ paddingRight: '20px' }}>
                <Typography className='fieldLabel'>Paid On</Typography>
                <input
                  name="iv_paid_on"
                  required
                  type='text'
                  onBlur={handleBlur}
                  value={values.iv_paid_on[0] ? convertDate(values.iv_paid_on[0]) : ''}
                  disabled
                  className='textInputField1'
                  style={{
                    width: '100%',
                    backgroundColor: '#006ad1', // Set background color here
                    color: 'white', // Set background color here
                    borderRadius: '5px',
                    height: '32.5px',
                    border: '1px solid lightgrey',
                    padding: '0px 5px'
                  }}
                />
                <Box className='from-Error'>
                  {errors.iv_paid_on && touched.iv_paid_on ? (errors.iv_paid_on) : null}
                </Box>
              </Grid> */}
            </Grid>
            {
              isPendingPayments &&
              <>
                <Typography variant="h6" className="groupTitle">
                  <div className="cyanCell">
                  </div>
                  Last Paid Amounts
                </Typography>
                <Grid container className='container'>
                  <Grid item xs={3} sx={{ backgroundColor: '#f0f0f0', color: 'black' }}>
                    <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                      <thead>
                        <tr style={{ backgroundColor: '#006ad1', color: 'white' }}>
                          <th style={{ border: '1px solid #ccc', padding: '8px', textAlign: 'left' }}>Sr.</th>
                          <th style={{ border: '1px solid #ccc', padding: '8px', textAlign: 'left' }}>Amount Paid</th>
                          <th style={{ border: '1px solid #ccc', padding: '8px', textAlign: 'left' }}>Paid On</th>
                        </tr>
                      </thead>
                      <tbody>
                        {values.iv_last_paid_amount.map((amount, index) => (
                          <tr key={index}>
                            <td style={{ border: '1px solid #ccc', padding: '8px' }}>{index + 1}</td>
                            <td style={{ border: '1px solid #ccc', padding: '8px' }}>{amount ? numberFormatting(amount) : ''}</td>
                            <td style={{ border: '1px solid #ccc', padding: '8px' }}>
                              {values.iv_paid_on[index] ? convertDate(values.iv_paid_on[index]) : ''}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </Grid>
                </Grid>
              </>
            }
            <Grid container >
              <Grid item lg={12} sx={{ margin: '0px 50px 0px 25px' }}>
                {
                  error &&
                  <Error
                    error={error}
                    onClose={() => errorCloses()}
                    backgroundColor="#FFC0CB"
                    textColor="#bb0303"
                    iconColor="#bb0303"
                  />
                }
              </Grid>
            </Grid>
            <Box sx={{ marginTop: "1%", textAlign: "right", marginRight: '2%', marginBottom: '2%' }}>
              <Button
                variant="contained" component="label" type='submit' onClick={handleSubmit}
                disabled={
                  (searchBy == 'consumerId' && values.iv_consumer_id.length != 10)
                  ||
                  (searchBy == 'referenceNo' && values.iv_reference_number.length != 14)
                  ||
                  error != ''}
              >
                Submit
              </Button>
            </Box>
          </form >
        </Box >
      </Grid >

      <FormSubmissionSuccessDialog
        open={billCorrectionPopup}
        onClose={handleClose}
        title="RCO request entered"
        trackingId={applicationId}
      >
        <Button
          variant="outlined"
          onClick={() => downloadBill(referenceNumber)}
          sx={{
            backgroundColor: 'white',
            cursor: 'pointer',
            border: '1px solid #006ad1',
            boxShadow: 'none',
            textTransform: 'none',
          }}
          startIcon={<DescriptionIcon sx={{ color: '#006ad1' }} />}
        >
          Bill
        </Button>
      </FormSubmissionSuccessDialog>

      {/* Backdrop */}
      < Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1000 }}
        open={viewBackdrop}
      >
        <AppLoader />
      </Backdrop >

    </>
  );
}

export default BillCorrectionForm; 